import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [seconds, setSeconds] = useState(299);
  useEffect(() => {
    if (seconds <= 0) return;
    const interval = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds]);
  if (seconds === 0) {
    return <span className="font-mono font-bold text-red-400 text-sm tracking-widest" data-id="element-1">
        OFFER EXPIRED
      </span>;
  }
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const formatted = `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  return <span className="font-mono font-bold text-yellow-300 text-sm tracking-widest tabular-nums" data-id="element-2">
      {formatted}
    </span>;
}